import '../chunk-PZ5AY32C.js';

// src/story/citations.ts
var NO_REFS = /* @__PURE__ */ new Set();
var NO_STEPS = Object.freeze([]);
function stepsByRef(acts, { slotMembers, slotOf }) {
  const byRef = /* @__PURE__ */ new Map();
  acts.forEach((act, index) => {
    for (const ref of slotMembers.get(slotOf(act.id)) ?? []) {
      const steps = byRef.get(ref);
      const step = { index, actId: act.id, title: act.title };
      if (steps) steps.push(step);
      else byRef.set(ref, [step]);
    }
  });
  return byRef;
}
function refsCitedBy(actIds, { slotMembers, slotOf }) {
  if (actIds.length === 1) return slotMembers.get(slotOf(actIds[0])) ?? NO_REFS;
  const out = /* @__PURE__ */ new Set();
  for (const id of actIds) for (const ref of slotMembers.get(slotOf(id)) ?? []) out.add(ref);
  return out.size === 0 ? NO_REFS : out;
}
function mergeCitedSteps(...lists) {
  const byId = /* @__PURE__ */ new Map();
  for (const list of lists) for (const step of list ?? []) if (!byId.has(step.actId)) byId.set(step.actId, step);
  return [...byId.values()].sort((a, b) => a.index - b.index);
}
function stepNumber(step) {
  return `Step ${step.index + 1}`;
}
function stepName(step) {
  const title = step.title.trim();
  return title ? `${stepNumber(step)} \u201C${title}\u201D` : stepNumber(step);
}
function stepsLabel(steps) {
  if (steps.length === 0) return "";
  if (steps.length === 1) return stepNumber(steps[0]);
  const numbers = steps.map((s) => String(s.index + 1));
  return `Steps ${numbers.slice(0, -1).join(", ")} and ${numbers[numbers.length - 1]}`;
}
function stepsTitle(steps) {
  if (steps.length === 0) return "";
  return `In the story: ${steps.map(stepName).join("; ")}`;
}

export { NO_REFS, NO_STEPS, mergeCitedSteps, refsCitedBy, stepName, stepNumber, stepsByRef, stepsLabel, stepsTitle };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map